import { useEffect, useMemo, type ReactNode } from "react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Flex, type ButtonProps } from "@chakra-ui/react";
import { useRouteLoaderData } from "react-router-dom";
import { SelectInput } from "components/inputs/select-input";
import { usePropertyTenancy } from "contexts/property-tenancy-provider";
import type { TenantSettingsLoaderData } from "types/tenancy";

type PropertySelectorProps = {
  menuButtonProps?: ButtonProps;
  overLineTextColor?: string;
  overlineText?: string;
  prefixIcon?: ReactNode;
};

export function PropertySelector({
  menuButtonProps,
  overlineText,
  prefixIcon,
  overLineTextColor,
}: PropertySelectorProps) {
  const { setPropertyTenancyId, propertyTenancyId: selectedPropertyTenancy } =
    usePropertyTenancy();

  const data = useRouteLoaderData("tenant-root") as TenantSettingsLoaderData;

  const propertyTenancies = useMemo(() => data?.tenantProperties ?? [], [data]);

  useEffect(() => {
    if (propertyTenancies.length === 0) return;

    const exists = propertyTenancies.some(
      (p) => String(p.id) === selectedPropertyTenancy,
    );

    if (!selectedPropertyTenancy || !exists) {
      setPropertyTenancyId(String(propertyTenancies[0].id));
    }
  }, [propertyTenancies, selectedPropertyTenancy, setPropertyTenancyId]);

  const groups = [
    {
      label: { id: "renting", value: "Renting" },
      options: propertyTenancies.map((l) => ({
        label: l.property_display_name,
        value: String(l.id),
      })),
    },
  ];
  return (
    <Flex direction={"column"} w={"100%"} mb={14}>
      <Flex h={12} align={"center"} justify={"center"} gap={2}>
        <SelectInput
          optionGroups={groups}
          menuItemProps={{ my: 2, borderRadius: "md" }}
          menuListProps={{ px: 2 }}
          value={selectedPropertyTenancy}
          onChange={(value) => {
            setPropertyTenancyId(value);
          }}
          menuProps={{
            matchWidth: true,
            gutter: 0,
            autoSelect: false,
            isLazy: true,
          }}
          menuButtonProps={menuButtonProps}
          overlineTextColor={overLineTextColor}
          overlineText={overlineText}
          prefixIcon={prefixIcon}
          rightIcon={<ChevronDownIcon boxSize={"18px"} />}
        />
      </Flex>
    </Flex>
  );
}
